import React, { createContext, useContext, useState } from 'react';

const RideStatusContext = createContext();

export function RideStatusProvider({ children }) {
    const [rideInSearch, setRideInSearch] = useState(false);
    const [rideInProgress, setRideInProgress] = useState(false);

    return (
        <RideStatusContext.Provider value={{
            rideInSearch, setRideInSearch,
            rideInProgress, setRideInProgress,
        }}>
            {children}
        </RideStatusContext.Provider>
    );
}

export function useRideStatus() {
    return useContext(RideStatusContext);
}